// Copyright 2024, Imprivata, Inc.  All rights reserved.

import type React from 'react';
import { useTranslation } from 'react-i18next';
import './index';

import { ConfigProvider } from 'antd';

import enUS from 'antd/lib/locale/en_US';
import esES from 'antd/lib/locale/es_ES';
import frFR from 'antd/lib/locale/fr_FR';
import deDE from 'antd/lib/locale/de_DE';
import itIT from 'antd/lib/locale/it_IT';
import ptBR from 'antd/lib/locale/pt_BR';
import nlNL from 'antd/lib/locale/nl_NL';

export const antLocales = {
  en: enUS,
  es: esES,
  fr: frFR,
  de: deDE,
  it: itIT,
  pt: ptBR,
  nl: nlNL,
};

export const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { i18n } = useTranslation();
  const rawLang = i18n.language?.split('-')[0] || 'en';

  const locale = antLocales[rawLang as keyof typeof antLocales] || enUS;

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
};
